import axios from "axios";
import { logout_func3 } from "../Const/logoutCommon";
import { BASE_URL } from "../Const/Url";
export const getTheme = (setTheme) => {
  const url = `${BASE_URL}api/v1/inventory/inventory/themes/?limit=250`;

  axios
    .get(url)
    .then((res) => {
      // console.log(res.data.data.results);
      const result = res.data.data.results;
      const options = result.map((curr) => ({
        label: curr.name,
        value: curr.id,
      }));
      setTheme(options);
    })
    .catch((err) => {
      const message = JSON.parse(err.request.response).message;
      // console.log(err.request.response);
      if (
        message === "Invalid token." ||
        JSON.parse(err.request.response).code === 401
      ) {
        const history = { push: (path) => (window.location.href = path) };
        logout_func3(history);
      }
    });
};
